/**
 * Derives the breadcrumb/tab-bar route segments for Instance Detail (CT-4188)
 * from the current pathname. Pure so it can be unit-tested independently of
 * the layout component.
 */
export function buildInstanceRoutePaths(pathname, providerSlug, instanceId) {
  const segments = pathname.split('/');
  const providerIdx = segments.indexOf(providerSlug);
  const providerBase =
    providerIdx >= 0
      ? segments.slice(0, providerIdx + 1).join('/')
      : `/admin-studio/integrations/${providerSlug}`;
  const integrationsBase = providerIdx >= 0 ? segments.slice(0, providerIdx).join('/') || '/' : '/';
  const instanceIdx = segments.indexOf(instanceId);
  const instanceBase =
    instanceIdx >= 0
      ? segments.slice(0, instanceIdx + 1).join('/')
      : `${providerBase}/instances/${instanceId}`;
  const activePath = instanceIdx >= 0 ? (segments[instanceIdx + 1] ?? 'basic') : 'basic';

  return { providerBase, integrationsBase, instanceBase, activePath, basicPath: `${instanceBase}/basic` };
}
